import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom'


const WebDevDiv2 = () => {
    const stats = [
        { icon: '🚀', number: '15+', label: 'Years Experience' },
        { icon: '🤝', number: '20+', label: 'Talented Squad' },
        { icon: '📱', number: '100+', label: 'Websites Developed' },
        { icon: '💻', number: '97%', label: 'Projects Delivered' },
        { icon: '🌍', number: '10+', label: 'Countries Served' },
        { icon: '😊', number: '97%', label: 'Client Satisfaction' },
    ];

    const cardStyle = {
        backgroundColor: 'white',
        borderRadius: '12px',
        transition: 'all 0.3s ease',
        boxShadow: '0 0 0 transparent',
    };

    const cardHoverStyle = {
        boxShadow: '0 10px 20px rgba(0, 0, 0, 0.15)',
        transform: 'translateY(-3px)',
    };

    return (
        <Container fluid className="py-5 container">
            <Row className="align-items-start justify-content-center">
                {/* Left Side Text */}
                <Col lg={6} className="text-start">
                   
                    <h1 className="fw-bold text-dark">Website Development Company</h1>
                    <p className="text-muted">
                        Warals Technology is India's most respected website design and development company, offering a wide range of clients industry-leading web solutions. We offer cutting-edge custom website design services focused on aesthetics and usability. More than 500 different websites have been developed by our experts. As a result, you can rely on us!
                    </p>
                    <h3 className="fw-bold text-dark">Guaranteed SEO-Friendly Websites.</h3>
                    <p className="text-muted">
                        For over 10 years, we have been the leading Indian website design agency, delivering cutting-edge design and website development services. Every website we create is tailored to your target demographic and search engine results.
                    </p>
                    {/* <h4 className="fw-bold text-dark">Let's Work on a New Project.</h4>
                    <Link
                        to="/ContactPage"
                        className="btn btn-light d-inline-flex align-items-center gap-2 px-4 py-2 fw-semibold rounded-pill my-3 shadow-sm"
                        style={{ fontSize: '1.1rem', color: '#00b8f1', border: "1px solid rgb(4,180,228)" }}
                    >
                        Contact Us
                    </Link> */}

                </Col>

                {/* Right Side Cards */}
                <Col lg={6}>
                    <Row className="g-3">
                        {stats.map((stat, index) => (
                            <Col md={4} sm={6} xs={6} key={index}>
                                <Card
                                    className="text-center p-3 h-100"
                                    style={cardStyle}
                                    onMouseEnter={(e) => {
                                        Object.assign(e.currentTarget.style, cardHoverStyle);
                                    }}
                                    onMouseLeave={(e) => {
                                        Object.assign(e.currentTarget.style, cardStyle);
                                    }}
                                >
                                    <div className="fs-2">{stat.icon}</div>
                                    <h5 className="fw-bold text-primary mt-2">{stat.number}</h5>
                                    <p className="text-muted">{stat.label}</p>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>

        </Container>
    );
};

export default WebDevDiv2;
